<template>
    <div :class="['find-a-doctor-dropdown-filter', { '-is-loading': loading }]">
        <label class="label find-a-doctor-dropdown-filter__label" :for="`dropdown-filter-${_uid}`" v-text="label" v-if="label" />
        <select
            :class="['select', 'find-a-doctor-dropdown-filter__input', { '-disabled': disabled }]"
            :id="`dropdown-filter-${_uid}`"
            :disabled="disabled"
            :value="value"
            @change="handleChange"
        >
            <option :value="null" v-if="placeholder" selected>{{ placeholder }}</option>
            <option
                v-for="(option, key) in options"
                :value="option.key"
                :key="key"
                v-text="option.value"
                :selected="value === option.value"
            />
        </select>
    </div>
</template>

<script>
import $mediator from 'wee-mediator';

export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        label: {
            type: String,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
        },
    },
    methods: {
        handleChange(event) {
            this.$emit('change', event.target.value);
        }
    },
}
</script>
